import { WorkRequestType } from '@prisma/client';

export const WORK_REQUEST_CONFIG: Partial<
  Record<WorkRequestType, { heading: string; urlPrefix: string }>
> = {
  [WorkRequestType.USIncorporation]: {
    heading: 'US Incorporation',
    urlPrefix: '/incorporate/us',
  },
  [WorkRequestType.CAIncorporation]: {
    heading: 'Canadian Incorporation',
    urlPrefix: '/incorporate/ca',
  },
  [WorkRequestType.SGIncorporation]: {
    heading: 'Singapore Incorporation',
    urlPrefix: '/incorporate/sg',
  },
  [WorkRequestType.USBankAccountInformationCollectionRequest]: {
    heading: 'US Bank Account Information Collection',
    urlPrefix: '/incorporate/us/bank-account',
  },
  [WorkRequestType.INLLPFormation]: {
    heading: 'LLP Formation',
    urlPrefix: '/incorporate/in/llp',
  },
  [WorkRequestType.INIncorporation]: {
    heading: 'Indian Private Limited Formation',
    urlPrefix: '/incorporate/in/pvt',
  },
  [WorkRequestType.GBIncorporation]: {
    heading: 'United Kingdom Incorporation',
    urlPrefix: '/incorporate/gb',
  },
  [WorkRequestType.AEIncorporation]: {
    heading: 'UAE Incorporation',
    urlPrefix: '/incorporate/ae',
  },
};



